import React from 'react';
import { ScheduledEmailFormVM } from './scheduled-email-form.viewmodel';
import { observer } from 'mobx-react';

interface IProps {
    vm: ScheduledEmailFormVM;
}

const ScheduledEmailFormMeetingSection = observer(({ vm }: IProps) => {
    const { meetingData } = vm;
    const formattedMeetingDate = vm.getDayStringInEventTimezone(meetingData.startDateTime);
    const formattedStartTime = vm.getFormmatedTime(meetingData.startDateTime);
    const formattedEndTime = vm.getFormmatedTime(meetingData.endDateTime);

    return (
        <section>
            <div className='scheduled-email-form__meeting-container'>
                <span className='scheduled-email-form__meeting-container--date'>{formattedMeetingDate}</span>
                <span className='scheduled-email-form__meeting-container--time'>
                    {formattedStartTime} - {formattedEndTime}
                </span>
                <span>{vm.meetingData.topic}</span>
            </div>
            <p className='scheduled-email-form__roles-container'>
                Roles: <span>{vm.meetingData.roles.join(', ')}</span>
            </p>
        </section>
    );
});

export { ScheduledEmailFormMeetingSection };
